/** Copyright 2025 Midas Healthcare Solutions - All Rights Reserved **/
import { MidasEffectError, FeatureFlag } from '@midas/shared/common';
import { createAction, props } from '@ngrx/store';

export const getFeatureFlags = createAction('[FeatureFlags] Get Feature Flags');
export const getFeatureFlagsSuccess = createAction(
  '[FeatureFlags] Get Feature Flags Success',
  props<{
    featureFlags: FeatureFlag[];
    count: number;
  }>(),
);
export const getFeatureFlagsError = createAction(
  '[FeatureFlags] Get Feature Flags Error',
  props<MidasEffectError>(),
);
